import { Api } from 'helpers/ApiClient';

export class Feedback {
  static async send(body) {
    try {
      const response = await Api.client.post('/api/v1/feedbacks', body);
      return response;
    } catch (e) {
      return {
        status: e.status,
        error: 'Service temporary unavailable!',
      };
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/feedback/api.js